import { render, staticRenderFns } from "./Consultar.vue?vue&type=template&id=89fe2346&scoped=true"
import script from "./Consultar.vue?vue&type=script&lang=js"
export * from "./Consultar.vue?vue&type=script&lang=js"
import style0 from "./Consultar.vue?vue&type=style&index=0&id=89fe2346&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89fe2346",
  null
  
)

export default component.exports